import { render, staticRenderFns } from "./browsForm.vue?vue&type=template&id=8ffed994&scoped=true"
import script from "./browsForm.vue?vue&type=script&lang=js"
export * from "./browsForm.vue?vue&type=script&lang=js"
import style0 from "./browsForm.vue?vue&type=style&index=0&id=8ffed994&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ffed994",
  null
  
)

export default component.exports